var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "position-relative"
  }, [_c('Multiselect', {
    class: ['motto-multi-select', _vm.changed ? 'motto-multi-select-changed' : ''],
    attrs: {
      "disabled": _vm.disabled,
      "placeholder": _vm.placeholder,
      "options": _vm.options,
      "multiple": true,
      "label": _vm.optionText ? _vm.optionText : null,
      "track-by": _vm.optionText ? _vm.optionText : null,
      "searchable": false,
      "show-labels": false,
      "block-keys": ['Tab', 'Enter']
    },
    on: {
      "input": function (changedValue) {
        _vm.$emit('input', changedValue);
      }
    },
    scopedSlots: _vm._u([{
      key: "tag",
      fn: function (_ref) {
        var option = _ref.option,
          remove = _ref.remove;
        return [_vm._t("tag", null, {
          "option": option,
          "remove": remove
        })];
      }
    }], null, true),
    model: {
      value: _vm.model,
      callback: function ($$v) {
        _vm.model = $$v;
      },
      expression: "model"
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }